<template lang="html">
  <span>🦊</span>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: () => ""
    }
  },
  computed: {
    currentShowDetails() {
      return this.$store.state.currentShowDetails;
    }
  },
  mounted() {
    if (this.id) {
      this.$store.dispatch("loadShowDetails", this.id);
    }
  }
};
</script>

<style lang="css" scoped></style>
